import createIcon from '../../createIcon';

/**
 * @component @name MedicationLiquid
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAzSDIuNVY1SDE0LjVWM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMy41IDZIMy41QzIuNCA2IDEuNSA2LjkgMS41IDhWMTlDMS41IDIwLjEgMi40IDIxIDMuNSAyMUgxMy41QzE0LjYgMjEgMTUuNSAyMC4xIDE1LjUgMTlWOEMxNS41IDYuOSAxNC42IDYgMTMuNSA2Wk0xMi41IDE1SDEwVjE3LjVIN1YxNUg0LjVWMTJIN1Y5LjVIMTBWMTJIMTIuNVYxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOS41IDZDMTcuODIgNiAxNi41IDcuNzYgMTYuNSAxMEMxNi41IDExLjc3IDE3LjMzIDEzLjIyIDE4LjUgMTMuNzZWMjBDMTguNSAyMC41NSAxOC45NSAyMSAxOS41IDIxQzIwLjA1IDIxIDIwLjUgMjAuNTUgMjAuNSAyMFYxMy43NkMyMS42NyAxMy4yMiAyMi41IDExLjc3IDIyLjUgMTBDMjIuNSA3Ljc2IDIxLjE4IDYgMTkuNSA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MedicationLiquid = createIcon('MedicationLiquid', [
  ['path', { d: 'M14.5 3H2.5V5H14.5V3Z', key: '1dgc5r' }],
  [
    'path',
    {
      d: 'M13.5 6H3.5C2.4 6 1.5 6.9 1.5 8V19C1.5 20.1 2.4 21 3.5 21H13.5C14.6 21 15.5 20.1 15.5 19V8C15.5 6.9 14.6 6 13.5 6ZM12.5 15H10V17.5H7V15H4.5V12H7V9.5H10V12H12.5V15Z',
      key: '1hoc2a',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 6C17.82 6 16.5 7.76 16.5 10C16.5 11.77 17.33 13.22 18.5 13.76V20C18.5 20.55 18.95 21 19.5 21C20.05 21 20.5 20.55 20.5 20V13.76C21.67 13.22 22.5 11.77 22.5 10C22.5 7.76 21.18 6 19.5 6Z',
      key: '1xrvf8',
    },
  ],
]);

export default MedicationLiquid;
